import React from "react";
import './ConfirmPopup.css'

function ConfirmPopup({ setConfirmPopupOpen, type, handleSubmit, state }) {
    return (
        <div className="ContainerSubmitedSucessConfirm">
            <div className="SubContainerSubmitedSucessConfirm">
                <img
                    className="deactive_closeBtn"
                    src="/images/cross-circle3.svg"
                    alt="close"
                    onClick={() => setConfirmPopupOpen(false)}
                />
                <div className="col-12 deactivate_msg" style={{ marginBottom: "30px", fontSize: "20px" }}>
                    {`Are you sure you want to submit?`}
                </div>
                <div className="row col-12 publish_deactive_btnBox">
                    <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={() => {
                        let assId =
                            type == "SA"
                                ? state.selfAssessmentId
                                : state.homeworkId;
                        let assType = type == "SA" ? "selfAssess" : "homework";
                        handleSubmit(assId, assType);
                    }}>
                        Yes
                    </button>
                    <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={() => setConfirmPopupOpen(false)}>
                        No
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmPopup;
